import FixEmailAction from '@/classes/SubmissionActions/FixEmailAction'
import FixOrUpgradeAction from '@/classes/SubmissionActions/FixOrUpgradeAction'
import { BaseEverplansStatus } from '@/classes/SubmissionStatuses/BaseEverplansStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import {
	EverplansEmailStatusEnum,
	type SubmissionAction,
} from '@/classes/SubmissionStatuses/types'

export class EmailError extends BaseEverplansStatus {
	getActions(): Array<SubmissionAction> {
		// If they are a basic account we want to also offer the option to upgrade
		if (this.submissionStatus.accountTier !== 'premium') {
			return [
				new FixOrUpgradeAction(
					this.submissionStatus.emailStatus!.status, // TODO see if we can type narrow this
					this.submissionStatus.requestedAccountTier,
					this.submissionStatus.lastSubmittedEmail,
					this.submissionStatus.paymentAmount
				),
			]
		}
		return [
			new FixEmailAction(
				this.submissionStatus.emailStatus!.status, // emailFailed confirms emailStatus is set
				this.submissionStatus.lastSubmittedEmail
			),
		]
	}

	getStatusText() {
		const accountTierLabel =
			this.submissionStatus.accountTier === 'premium' ? 'Lifetime' : 'Basic'

		switch (this.submissionStatus.emailStatus?.status) {
			case EverplansEmailStatusEnum.BLANK:
				return accountTierLabel + ' | Missing Email'
			case EverplansEmailStatusEnum.INVALID:
				return 'Invalid Email'
			case EverplansEmailStatusEnum.DUPLICATE:
				return 'Duplicate Email'
			default:
				return 'Email Error'
		}
	}

	getToolTipText() {
		let title = this.getStatusText()
		let body = ''

		switch (this.submissionStatus.emailStatus?.status) {
			case EverplansEmailStatusEnum.BLANK:
				body = 'There is no email attached to this Everplans account.'
				break
			case EverplansEmailStatusEnum.INVALID:
				body = 'This email does not exist.'
				break
			case EverplansEmailStatusEnum.DUPLICATE:
				body = 'This email already exists in the Everplans system.'
				break
			default:
				body = 'Email Error.'
				break
		}
		return {
			title: title,
			body:
				body +
				' Click Fix button to update and submit to ' +
				this.getVendorName() +
				'. Have questions? Contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
